import React from "react";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import CheckBox from "../inputs/CheckBox";

type filterName = "coach" | "player" | "viewer";

interface Props {
  onChange: (isChecked: { [key in filterName]: boolean }) => void;
  memberFilterParams: { coach: boolean; player: boolean; viewer: boolean };
}

const MembersRoleFilter: React.FC<Props> = ({
  onChange,
  memberFilterParams,
}) => {
  const { t } = useTranslation();

  const filterData: {
    label: string;
    name: filterName;
    isActive: boolean;
  }[] = [
    {
      label: t("Coaches/Admins"),
      name: "coach",
      isActive: memberFilterParams.coach,
    },
    {
      label: t("Members"),
      name: "player",
      isActive: memberFilterParams.player,
    },
    {
      label: t("Viewers"),
      name: "viewer",
      isActive: memberFilterParams.viewer,
    },
  ];

  const onChangeHandler = (name: filterName) => {
    onChange({ ...memberFilterParams, [name]: !memberFilterParams[name] });
  };

  return (
    <div className={styles.dropdown_container}>
      <label>{t("Filter by Role")}</label>
      <div className={styles.checkbox_container}>
        {filterData?.map((data, index) => (
          <div key={index}>
            <CheckBox
              testId={`${data.name}_checkbox`}
              name={data.name}
              checked={data.isActive}
              onChange={() => onChangeHandler(data.name)}
              label={data.label}
              squareCheckIcons
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MembersRoleFilter;
